var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H68V68H0V0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1920_2785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7949 35.57C43.8183 36.6546 43.3266 37.0978 42.259 37.0601C40.9151 37.0129 39.5618 37.046 38.0166 37.046C38.0166 38.4324 38.0213 39.7716 38.0166 41.1108C38.0072 42.5916 37.8246 42.7802 36.387 42.7849C35.1462 42.7896 33.9053 42.7613 32.6644 42.7943C31.6904 42.8226 31.2549 42.3982 31.269 41.4174C31.2924 39.9932 31.2737 38.5691 31.2737 37.046C29.7284 37.046 28.3096 37.0224 26.8954 37.0554C25.9168 37.079 25.4954 36.6168 25.5 35.6596C25.5094 34.3015 25.5094 32.9433 25.5 31.5805C25.4954 30.6044 25.9777 30.1941 26.9329 30.2083C28.3143 30.2366 29.7003 30.2177 31.2737 30.2177C31.2737 28.7276 31.3111 27.3742 31.2643 26.0208C31.2268 24.9079 31.6342 24.3892 32.7955 24.441C34.0692 24.5023 35.3475 24.4835 36.6259 24.4457C37.5998 24.4175 38.0353 24.8419 38.0213 25.8227C37.9978 27.2468 38.0166 28.671 38.0166 30.2177C39.515 30.2177 40.8917 30.246 42.2684 30.2083C43.336 30.1753 43.8183 30.6374 43.7949 31.7126C43.7668 32.9999 43.7668 34.2873 43.7949 35.57Z",
    fill: "#D3AA29"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1920_2785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6471 17C46.9971 17.425 39.2408 14.3438 34.4596 9.5625C29.6783 14.3438 21.9221 17.425 14.2721 17C14.2721 30.2812 8.95956 43.5625 34.4596 57.375C59.9596 43.5625 54.6471 30.2812 54.6471 17Z",
    stroke: "#005AA0",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1920_2785",
    x: 21.5,
    y: 22.4375,
    width: 26.2959,
    height: 26.3582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1920_2785"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1920_2785",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1920_2785",
    x: 8.3125,
    y: 5.44116,
    width: 52.2939,
    height: 59.6396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1920_2785"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1920_2785",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.fc5a42ec08d8e7eee22bb18cb2a1bc84.svg";
export { ForwardRef as ReactComponent };